<div class="app-shell" [class.login-shell]="isLoginRoute()">
  @if (!isLoginRoute()) {
    <aside class="sidebar">
      <a class="brand" routerLink="/dashboard">
        Do Your Shades
        <span class="brand-sub">Supplier Portal</span>
      </a>

      <nav class="nav">
        <a routerLink="/dashboard" routerLinkActive="active" [ariaCurrentWhenActive]="'page'">Dashboard</a>
        <a routerLink="/orders/new" routerLinkActive="active" [ariaCurrentWhenActive]="'page'">New orders</a>
        <a routerLink="/orders/in-progress" routerLinkActive="active" [ariaCurrentWhenActive]="'page'">In progress</a>
        <a routerLink="/orders/past" routerLinkActive="active" [ariaCurrentWhenActive]="'page'">Past orders</a>
        <a routerLink="/profile" routerLinkActive="active" [ariaCurrentWhenActive]="'page'">Profile</a>
      </nav>

      @if (supplier(); as s) {
        <div class="sidebar-footer">
          <span class="supplier-name">{{ s.name }}</span>
          <a class="password-link" routerLink="/change-password">Change password</a>
          <button type="button" class="logout-btn" (click)="logout()">Logout</button>
        </div>
      }
    </aside>
  }

  <main id="main-content" tabindex="-1" class="content" [class.login-content]="isLoginRoute()">
    <router-outlet></router-outlet>
  </main>
</div>
